export enum MAP_BUILD_NAMES {
  Mapix = "Mapix",
  Citronella = "External",
  CitronellaRoute = "ExternalRoute",

  GPS = "UnifiedMap",
  Unilever = "UnileverMap",
}

export enum MAP_MODULE_NAMES {
  Locations = "Control de Activos",
  Geofences = "Geocercas",
  Routes = "Rutas",
  Potential_Zones = "Zonas Potenciales",
  Frequency_Zones = "Frecuencia de ruta",
  CitronellaPoints = "CitronellaPoints",
  CitronellaRoute = "CitronellaRoute"
}

export enum MAP_COMPONENT_NAMES {
  DrawTools = "DrawTools",
  InfoBox = "InfoBox",
  PolygonSelector = "PolygonSelector",
  ValetParking = "ValetParking",
  LayersPanel = "Layers"
}
  
